import { buildWorkflow } from "./workflowBuilder";
import { useWorkflowContextStore } from "../../store/sendmoneyWorkflowContextStore";
import { useWorkflowStore } from "../../store/sendmoneyWorkflowStore";
import type { WorkflowContext } from "../types/workflowContext";
/**
 * Purpose:
 * Centralized workflow management service.
 *
 * Why:
 * Screens should not be responsible for
 * rebuilding workflows.
 *
 * Responsibilities:
 * - Update workflow context
 * - Rebuild workflow
 * - Update workflow store
 *
 * Does NOT:
 * - Call APIs
 * - Navigate
 * - Render UI
 */
class SendWorkflowManager {
  /**
   * Updates workflow context and rebuilds workflow.
   */
  updateContext(updates: Partial<WorkflowContext>): void {
    const workflowContextStore = useWorkflowContextStore.getState();
    const workflowStore = useWorkflowStore.getState();
    const updatedContext = {
      ...workflowContextStore.workflowContext,
      ...updates,
    };
    workflowContextStore.updateWorkflowContext(updates);
    console.log("updatedContext", updatedContext);
    const workflow = buildWorkflow(updatedContext);
    console.log("workflow", workflow);
    workflowStore.setWorkflow(workflow);
    // if (workflow.length > 0) {
    //   workflowStore.setCurrentStepKey(workflow[0].key);
    // }
  }

  /**
   * Returns current workflow context.
   */
  getContext(): WorkflowContext {
    return useWorkflowContextStore.getState().workflowContext;
  }

  /**
   * Forces workflow rebuild using
   * current context.
   */
  rebuildWorkflow(): void {
    const context = this.getContext();
    const workflow = buildWorkflow(context);
    const workflowStore = useWorkflowStore.getState();
    workflowStore.setWorkflow(workflow);
  }
}

export const sendWorkflowManager = new SendWorkflowManager();
